import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import React, { FC } from "react"
import { colors } from "../../utils/theme"

const useStyles = makeStyles((theme) => ({
  button: {
    padding: 0,
    margin: 0,
    border: 0,
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: "transparent",
    marginRight: theme.spacing(3),
    "&:focus": {
      outline: "none",
    },
  },
  buttonActive: {
    borderBottom: "2px solid",
    borderBottomColor: colors.secondary.peach,
  },
  inactiveButton: {
    borderBottom: "none",
  },
  buttonText: {
    "&:hover": {
      color: colors.primary.shadow,
    },
  },
  activeButtonText: {
    color: colors.neutral.space,
    fontWeight: "bold",
  },
  inactiveButtonText: {
    color: colors.neutral.space,
  },
}))

const NavigationButton: FC<{
  active: boolean
  onClick: () => void
  children: React.ReactNode
}> = ({ active, onClick, children }) => {
  const classes = useStyles()
  return (
    <button
      onClick={onClick}
      className={clsx(
        classes.button,
        active ? classes.buttonActive : classes.inactiveButton
      )}
    >
      <Typography
        variant="body1"
        className={clsx(
          classes.buttonText,
          active ? classes.activeButtonText : classes.inactiveButtonText
        )}
      >
        {children}
      </Typography>
    </button>
  )
}

export default NavigationButton
